import React from "react";
import {Route, Routes } from "react-router-dom";
import Login from "../views/auth/Login";
import FooterSmall from "../components/Footers/FooterSmall";

export default function Auth() {
  return (
    <>
      <main>
        <section className="relative w-full h-full py-20 min-h-screen">
        <div
            className="absolute top-0 w-full h-full bg-[#0471a3] bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("../assets/img/register_bg_2.png").default + ")",
            }}
          ></div>
          <Routes>
            <Route path="login" element={<Login/>} />
          </Routes>
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}
